import dayjs from 'dayjs';

declare global {
  interface Window {
    runConfig: {
      frontendUrl: string;
      backendUrl: string;
      nodeEnv: string;
      mansLauksUrl: string;
      llkcRegistryUrl: string;
    };
  }
}

export const routes = {
  api: {
    frontendUrl: window?.runConfig?.frontendUrl,
    baseUrl: window?.runConfig?.backendUrl,
    mansLauksUrl: window?.runConfig?.mansLauksUrl,
    llkcRegistryUrl: window?.runConfig?.llkcRegistryUrl,
  },
  admin: {
    beginning: '/',
    farmTransactions: '/admin/farm/transactions',
    transactions: '/admin/transactions',
    orders: '/admin/orders',
    farmUsers: '/admin/farm/users',
    farmContracts: '/admin/farm/contracts',
    products: '/admin/products',
    coupons: '/admin/coupons',
    quality_marks: '/admin/quality_marks',
    eShopEmail: '/admin/eshop-email',
    farmEmail: '/admin/farm-email',
    qmark: '/admin/qmark',
    users: '/admin/users',
    farms: '/admin/farms',
    contracts: '/admin/contracts',
    roles: '/admin/permissions',
    banners: '/admin/banners',
    topCategories: '/admin/top-categories',
    categories: '/admin/categories',
    globalSettings: '/admin/settings',
    catalogSettings: '/admin/catalog-settings',
    emarketSettings: '/admin/emarket-settings',
    notifications: '/admin/notifications',
    transferringUserFarms: '/admin/transfer-user-farm',
  },
};

export const options = {
  filters: {
    pageSizeOptions: [20, 40],
  },
  images: {
    defaultProductImage: '/defaults/image-not-found.jpeg',
    defaultImageNotFound: '/defaults/image-not-found.jpeg',
    defaultFarmImage: '/defaults/image-not-found.jpeg',
    defaultCategoryImage: '/defaults/image-not-found.jpeg',
    defaultBannerOneImage: '/banners/banner_1.png',
    defaultBannerTwoImage: '/banners/banner_2.png',
    defaultBannerThreeImage: '/banners/banner_3.png',
    defaultBannerFourImage: '/banners/banner_4.png',
    defaultFarmGaleryImage: '/defaults/farm_galery.png',
    maxImages: 3,
    maxImageSize: 1440,
    maxSizeInMB: 22,
    allowedFormats: ['image/png', 'image/jpeg', 'image/bmp'],
  },
  open_hours: {
    0: { no: '00:00', lidz: '00:00', closed: false },
    1: { no: '00:00', lidz: '00:00', closed: false },
    2: { no: '00:00', lidz: '00:00', closed: false },
    3: { no: '00:00', lidz: '00:00', closed: false },
    4: { no: '00:00', lidz: '00:00', closed: false },
    5: { no: '00:00', lidz: '00:00', closed: false },
    6: { no: '00:00', lidz: '00:00', closed: false },
  },
  toolbarOptions: [
    ['bold', 'italic', 'underline', 'strike'], // toggled buttons
    ['blockquote', 'code-block'],

    [{ header: 1 }, { header: 2 }], // custom button values
    [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }],
    [{ script: 'sub' }, { script: 'super' }], // superscript/subscript
    [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
    [{ direction: 'rtl' }], // text direction

    [{ size: ['small', false, 'large', 'huge'] }], // custom dropdown
    [{ header: [1, 2, 3, 4, 5, 6, false] }],

    [{ color: [] }, { background: [] }], // dropdown with defaults from theme
    [{ font: [] }],
    [{ align: [] }],

    ['clean'], // remove formatting button
  ],
  outstafDeliveries: [
    { label: 'Dpd pakomāts', value: 'Dpd pakomāts' },
    { label: 'Omniva pakomāts', value: 'Omniva pakomāts' },
    { label: 'Izipizi pakomāts', value: 'Izipizi pakomāts' },
    { label: 'Venipak pakomāts', value: 'Venipak pakomāts' },
  ],
};

export const links = {
  youtube: 'https://www.youtube.com/@novadagarsa1207/',
  instagram: 'https://www.instagram.com/novadagarsa/',
  facebook: 'https://www.facebook.com/NovadaGarsa/',
  venipak:
    'https://venipak.com/lv/produkti-un-pakalpojumi/pakalpojumi-e-komercijai/#Modulis-e-veikaliem',
  izipizi: 'https://business.izipiziapp.com/',
  omniva: 'https://www.omniva.lv/bizness/api/',
  dpd: 'https://eserviss.dpd.lv/order',
};

export const policyLinks = {
  cookiePolicy: 'https://novadagarsa.lv/llkc-sikdatnu-politika/',
  privacyPolicy: 'https://novadagarsa.lv/privatuma-politika/',
  termsOfUse: 'https://novadagarsa.lv/lietosanas-noteikumi-distances-ligums/',
};

export const headerLinks = {
  main: 'https://novadagarsa.lv/',
  about: 'https://novadagarsa.lv/par-novadu-garsa/',
  current_events: 'https://novadagarsa.lv/aktualitates/',
  contests: 'https://novadagarsa.lv/produktu-kvalitates-konkurss/',
  recipes: 'https://novadagarsa.lv/receptes/',
  events: 'https://novadagarsa.lv/pasakumi/',
  contacts: 'https://novadagarsa.lv/kontakti/',
  market: 'https://tirgus.novadagarsa.lv/',
};
